module.exports = __webpack_public_path__ + "img/liability-limits.f361cdd1.jpg";